export default "__VITE_ASSET__C0el2F50__"